// Ko'rsatish uchun formatlash: sana, telefon, pul, holatlar.
import { DEVICE_KINDS } from '@onepos/shared';
export { daysLeft, fmtAgo, fmtDate, fmtDateTime, fmtDaysLeft, fmtMoney, fmtMoneyShort, fmtPhone, initials } from '@onepos/shared';
import type { Tone } from '@onepos/ui';
import type { TenantStatus } from './types';

export const STATUS: Record<TenantStatus, { label: string; tone: Tone }> = {
  trial: { label: 'Sinov', tone: 'info' },
  active: { label: 'Faol', tone: 'success' },
  grace: { label: 'Muhlat', tone: 'warning' },
  suspended: { label: 'To‘xtatilgan', tone: 'danger' },
  deleted: { label: 'O‘chirilgan', tone: 'neutral' },
};

export function deviceKindLabel(kind: string): string {
  return (DEVICE_KINDS as Record<string, string>)[kind] ?? kind;
}

/** Tarif limitlari (Q-022): turi bo'yicha nom */
export const LIMIT_LABELS: Record<string, string> = {
  pos: 'kassa',
  kds: 'oshxona ekrani',
  printer: 'oshxona printeri',
  queue: 'mijoz ekrani',
  waiter: 'ofitsiant',
};

/** "2 kassa, 2 oshxona monitori" — nolga teng bo'lganlari ko'rsatilmaydi */
export function limitsText(limits: Record<string, number> | undefined): string {
  const parts = Object.entries(LIMIT_LABELS)
    .filter(([k]) => (limits?.[k] ?? 0) > 0)
    .map(([k, label]) => `${limits?.[k]} ${label}`);
  return parts.length ? parts.join(', ') : 'faqat ega qurilmalari';
}

export const AUDIT_ACTIONS: Record<string, string> = {
  'tenant.create': 'Restoran yaratildi',
  'tenant.update': 'Ma’lumotlar o‘zgardi',
  'tenant.status': 'Holat o‘zgardi',
  'tenant.trial': 'Sinov muddati o‘zgardi',
  'tenant.plan': 'Tarif o‘zgardi',
  'module.set': 'Bo‘lim o‘zgardi',
  'setting.set': 'Sozlama o‘zgardi',
  'note.set': 'Eslatma yozildi',
  'device.enable': 'Qurilma yoqildi',
  'device.disable': 'Qurilma uzildi',
  'support.start': 'Yordam rejimi ochildi',
  'support.end': 'Yordam rejimi yopildi',
  'owner.password_reset': 'Ega paroli tiklandi',
  'tenant.limits': 'Limitlar moslandi',
  'tenant.login_set': 'Restoran logini o‘zgardi',
  'library.image': 'Kutubxona rasmi yangilandi',
  'library.image_remove': 'Kutubxona rasmi olib tashlandi',
  'billing.pay': 'To‘lov qabul qilindi',
  'billing.void': 'To‘lov bekor qilindi',
  'billing.auto': 'Avtomatik to‘xtatish o‘zgardi',
  'billing.settings': 'Chegirma va rekvizitlar o‘zgardi',
  'plan.price': 'Tarif narxi o‘zgardi',
  'plan.update': 'Tarif tarkibi o‘zgardi',
  'billing.price_lock': 'Narx kafolati o‘zgardi',
  'tenant.privileged': 'Imtiyoz o‘zgardi',
};

/** To'lov usullari (obuna, Q-064) */
export const PAY_METHODS: Record<string, string> = {
  transfer: 'Bank o‘tkazmasi',
  cash: 'Naqd',
  card: 'Karta',
  click: 'Click',
  payme: 'Payme',
  uzum: 'Uzum',
  other: 'Boshqa',
};

export function monthsText(n: number): string {
  return n === 12 ? '1 yil' : `${n} oy`;
}

export function auditLabel(action: string): string {
  return AUDIT_ACTIONS[action] ?? action;
}
